import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17.03 5L3 5.01v13.98l14.03.01L22 12l-4.97-7z"
}), 'LabelSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LabelSharp.js
// module id = 4388
// module chunks = 2